export default "__VITE_ASSET__CrwLqCMs__"